export class ServiceKey {
  serviceCode?: string;

  serviceTypeCode?: string;
}
